import React, { useMemo } from 'react';
import { TouchableOpacity } from 'react-native';
import { Popover, } from '@alucio/lux-ui';
const SettingPopOverDialog = (props) => {
    const { onClose, children, visible } = props;
    const closeHandler = () => {
        onClose && onClose();
    };
    const [Anchor, content] = useMemo(() => {
        return React.Children
            .toArray(children)
            .reduce((acc, child) => {
            var _a;
            if (React.isValidElement(child)) {
                // @ts-expect-error
                const displayName = (_a = child.type) === null || _a === void 0 ? void 0 : _a.displayName;
                if (displayName === SettingPopOverDialogAnchor.displayName) {
                    acc[0] = child;
                }
                else if (displayName === SettingPopOverDialogContent.displayName) {
                    acc[1] = child;
                }
            }
            return acc;
        }, []);
    }, [children]);
    return (React.createElement(Popover, { lazyMount: true, interactive: true, offset: 10, placement: "bottom-start", type: "menu", visible: visible, onBackdropPress: closeHandler },
        React.createElement(Popover.Anchor, null,
            React.createElement(TouchableOpacity, { onPress: props.onPress }, Anchor)),
        React.createElement(Popover.Content, null, content)));
};
const SettingPopOverDialogAnchor = (props) => props.children;
const SettingPopOverDialogContent = (props) => props.children;
SettingPopOverDialogAnchor.displayName = 'Anchor';
SettingPopOverDialogContent.displayName = 'Content';
SettingPopOverDialog.Anchor = SettingPopOverDialogAnchor;
SettingPopOverDialog.Content = SettingPopOverDialogContent;
export default SettingPopOverDialog;
//# sourceMappingURL=SettingPopOverDialog.js.map